export default "__VITE_ASSET__DmOw2HHc__"